/* a11y shims for app-injected forms the theme cannot edit at source (2026-09 audit).
   Globo Form Builder: name radio/checkbox groups, mark required fields, declare input purpose.
   Remove a block when the vendor ships the fix. */
(function () {
  function patchGlobo(root) {
    root.querySelectorAll('.globo-form-app fieldset').forEach(function (fs, i) {
      if (fs.querySelector('legend') || fs.getAttribute('aria-labelledby') || fs.getAttribute('aria-label')) return;
      var ctrl = fs.closest('.globo-form-control');
      var label = ctrl && ctrl.querySelector('label.globo-label, .label-content');
      if (!label) return;
      if (!label.id) label.id = 'a11y-globo-group-' + i;
      fs.setAttribute('role', 'group');                       // SC 1.3.1 / 4.1.2
      fs.setAttribute('aria-labelledby', label.id);
      var lg = document.createElement('legend'); lg.className = 'visually-hidden'; lg.textContent = label.textContent.trim(); fs.insertBefore(lg, fs.firstChild);
    });
    root.querySelectorAll('.globo-form-app [presence]').forEach(function (el) {
      if (!el.hasAttribute('aria-required')) el.setAttribute('aria-required', 'true');   // SC 3.3.2
    });
    root.querySelectorAll('.globo-form-app input').forEach(function (el) {
      if (el.hasAttribute('autocomplete')) return;
      var label = ((el.labels && el.labels[0] && el.labels[0].textContent) || el.placeholder || '').trim().toLowerCase();
      var token = /^first name/.test(label) ? 'given-name' : /^last name/.test(label) ? 'family-name' :
                  /^(full )?name/.test(label) ? 'name' : /^e-?mail/.test(label) ? 'email' : /^phone/.test(label) ? 'tel' : '';
      if (token) el.setAttribute('autocomplete', token);      // SC 1.3.5
    });
  }
  // Cart drawer opened by Add to Cart: return focus to that button when the drawer closes. SC 2.4.3
  var addBtn = null;
  document.addEventListener('submit', function (e) {
    if (e.target && e.target.matches && e.target.matches('form[action*="/cart/add"]')) addBtn = e.target.querySelector('[name="add"]');
  }, true);
  new MutationObserver(function () {
    var open = document.documentElement.classList.contains('no-scroll');
    if (!open && addBtn) {
      var b = addBtn; addBtn = null;
      setTimeout(function () { if (document.activeElement === document.body && document.contains(b)) b.focus(); }, 50);
    }
  }).observe(document.documentElement, { attributes: true, attributeFilter: ['class'] });

  // Hidden app and pixel iframes have no title. They never reach a user; the title satisfies SC 4.1.2 for scanners.
  function patchFrames() {
    document.querySelectorAll('iframe:not([title])').forEach(function (f) {
      var r = f.getBoundingClientRect();
      if (r.width <= 1 && r.height <= 1 || getComputedStyle(f).display === 'none' || getComputedStyle(f).visibility === 'hidden') { f.setAttribute('title', 'Hidden helper frame'); f.setAttribute('aria-hidden', 'true'); }
    });
  }
  // Klaviyo Customer Hub launcher is injected first in <body>, so it is the first tab stop, before the skip link (SC 2.4.1).
  function patchLauncher() {
    var l = document.querySelector('.kl-hub-launcher-container');
    if (l && l.parentElement === document.body && document.body.lastElementChild !== l) document.body.appendChild(l);
  }
  // Facet filter forms submit on change; give keyboard users an explicit submit. SC 3.2.2
  function patchFacets() {
    document.querySelectorAll('#FacetFiltersForm, #FacetFiltersFormMobile').forEach(function (f) {
      if (f.querySelector('button[type=submit], input[type=submit]')) return;
      var b = document.createElement('button'); b.type = 'submit'; b.className = 'visually-hidden'; b.textContent = 'Apply filters'; f.appendChild(b);
    });
  }
  function run() { patchGlobo(document); patchFrames(); patchLauncher(); patchFacets(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
  // Globo mounts after load.
  var n = 0, t = setInterval(function () { run(); if (++n > 20) clearInterval(t); }, 500);
})();
